/**
 * require.context(directory, useSubdirectories, regExp)
 * directory：表示检索的目录
 * useSubdirectories：表示是否检索子文件夹
 * regExp：匹配文件的正则表达式，一般是文件名
 */
import en_us from '../en-us';

const requireAll = requireContext => {
  try {
    return requireContext.keys().map(key => {
      try {
        return requireContext(key);
      } catch (error) {
        console.error(`Failed to load module ${key}:`, error);
        return {};
      }
    });
  } catch (error) {
    console.error('Failed to load modules:', error);
    return [];
  }
};

const req = require.context('./module/', true, /\.js$/);
let zh_cn = {};

try {
  const modules = requireAll(req);
  if (modules.length > 0) {
    modules.forEach(item => {
      Object.assign(zh_cn, item.default);
    });
  } else {
    console.warn('No modules found in ./module/');
  }
} catch (error) {
  console.error('Error processing modules:', error);
}

export default zh_cn;
